<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/1HTyVN/tc-custom/9780292763791.jpg?1740533950419" alt="This image is the cover for the book Euro-American Cinema, Texas Film and Media Studies Series"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Euro-American Cinema, Texas Film and Media Studies Series
      </h1>
      <p class="bookDescription body article font2">
        <p><b>From as scholar of mass communications, an international study of the influence of Hollywood movies on twentieth-century European art films.</b><br/>  <br/> With McDonalds in Moscow and Disneyland in Paris and Tokyo, American popular culture is spreading around the globe. Regional, national, and ethnic cultures are being powerfully affected by competition from American values and American popular forms. This literate and lively study explores the spread of American culture into international cinema as reflected by the collision and partial merger of two important styles of filmmaking: the Hollywood style of stars, genres, and action, and the European art film style of ambiguity, authorial commentary, and borrowings from other arts.<br/><br/> Peter Lev departs from the traditional approach of national cinema histories and discusses some of the blends, overlaps, and hegemonies that are typical of the world film industry of recent years. In Part One, he gives a historical and theoretical overview of what he terms the “Euro-American art film,” which is characterized by prominent use of the English language, a European art film director, cast and crew from at least two countries, and a stylistic mixing of European art film and American entertainment.<br/><br/> The second part of Lev’s study examines in detail five examples of the Euro-American art film: <i>Contempt</i><i> (</i>1963), <i>Blow-Up</i> (1966), <i>The Canterbury Tales</i> (1972), <i>Paris, Texas</i> (1983), and <i>The Last Emperor</i> (1987). These case studies reveal that the European art film has had a strong influence on world cinema and that many Euro-American films are truly cultural blends rather than abject takeovers by Hollywood cinema. </p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Peter Lev
      </h2>
      
      <p class="authorDescription body article"> Peter Lev is an associate professor of mass communication at Towson State University. </p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      University of Texas Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?3f040cd2